import { GenIcon } from 'react-icons';
export const MdCurrencyFlagDkk = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_31927)' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.9947 11.9964C23.9947 12.5773 23.9549 13.1529 23.8727 13.7099C23.0371 19.5191 18.0318 23.9966 11.9947 23.9966C11.2652 23.9966 10.549 23.9303 9.85409 23.8057C8.63923 23.5855 7.48275 23.1796 6.42705 22.6226C3.09018 20.8666 0.676382 17.5854 0.122006 13.7099C0.04243 13.1529 0 12.5799 0 11.9964C0 11.4128 0.0397774 10.8398 0.122006 10.2828C0.676382 6.41003 3.09018 3.12614 6.42705 1.37278C7.48541 0.813089 8.64188 0.409899 9.85409 0.189735C10.549 0.0624112 11.2652 -0.00390625 11.9947 -0.00390625C18.0292 -0.00390625 23.0371 4.4763 23.8727 10.2828C23.9523 10.8398 23.9947 11.4128 23.9947 11.9964Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.9947 11.998C23.9947 12.5789 23.9549 13.1546 23.8727 13.7116H9.85409V23.8073C8.63923 23.5872 7.48275 23.1813 6.42705 22.6243V13.7116H0.122006C0.04243 13.1546 0 12.5816 0 11.998C0 11.4145 0.0397774 10.8415 0.122006 10.2845H6.42705V1.37445C7.48541 0.81476 8.64188 0.41157 9.85409 0.191406V10.2845H23.8727C23.9523 10.8415 23.9947 11.4145 23.9947 11.998Z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_31927' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
